import React, { useState, useEffect } from 'react';
import { Route, useLocation } from 'react-router-dom';
import NonAuth from './nonAuth.js';

// ProtectedRoute component
const ProtectedRoute = ({ component: Component, permissions, moduleName, ...rest }) => {
  const [hasPermission, setHasPermission] = useState(false);
  const location = useLocation(); // Hook to get the current location

  useEffect(() => {
    // Fetch the roleManager from localStorage whenever the component mounts or updates
    const userPermissions = ["access"];
    const allModules = JSON.parse(localStorage.getItem('roleManager')) || {};

    // Check if the module exists and if user has permissions
    const moduleExists = allModules.hasOwnProperty(moduleName);
    const permissionGranted = moduleExists && permissions.every(permission => userPermissions.includes(permission));
    setHasPermission(permissionGranted);
  }, [permissions, moduleName, location]); // Re-run whenever permissions or moduleName change

  return (
    <Route
      {...rest}
      render={props =>
        hasPermission ? (
          <Component {...props} />
        ) : (
          <NonAuth />
        )
      }
    />
  );
};

export default ProtectedRoute;
